<template>
    <div class="modelScan">
        <el-select v-model="value" filterable placeholder="请选择">
            <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.danwei"
                :value="item.id"
            >
            </el-option>
        </el-select>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>产品信息</span>
            </div>
            <div class="text item">
                <span>商品名称：</span>
                <span>{{ productInfo.store_name }}</span>
            </div>
            <div class="text item">
                <span>价格：</span>
                <span>{{ productInfo.ot_price }}</span>
            </div>
            <div class="text item">
                <span>防伪码：</span>
                <span>{{ productInfo.serial_code }}</span>
            </div>
            <div v-if="productInfo.status == '1'" class="text item">
                <span>代理商：</span>
                <span>{{ productInfo.danwei }}</span>
            </div>
        </el-card>
        <el-card class="box-card bottomBtn">
            <div class="text item">
                <el-button class="scanBtn" @click="stock_goods" type="primary"
                    >出库</el-button
                >
            </div>
            <div class="text item">
                <el-button class="scanBtn" @click="scanCode" type="primary"
                    >扫码</el-button
                >
            </div>
            <!-- 228平台 -->
            <!-- 迪哥本地55平台 -->
            <div class="text item" v-if="$store.state.app.shopid == 228">
                <el-button
                    class="scanBtn"
                    @click="continuousScanCode"
                    type="primary"
                    >连续扫码出库</el-button
                >
            </div>
        </el-card>
    </div>
</template>

<script>
import { get_agent, get_goods, stock_goods } from "../../api/roots";
import { getWechatConfig } from "../../api/public";
import { getQueryValue } from "@utils/utils";
import wx from "weixin-js-sdk";
import $store from "../../store";
export default {
    name: "ScanCode",
    data: function () {
        return {
            options: [],
            productInfo: [],
            value: "",
            wechatConfig: [],
            shopid: "",
        };
    },
    created() {
        this.shopid = $store.state.app.shopid;
    },
    mounted: function () {
        var LOGIN = JSON.parse(localStorage.getItem("LOGIN"));
        var NOW = Date.parse(new Date());
        if (LOGIN && LOGIN.expires_time) {
            var utc = NOW - LOGIN.expires_time;
            var interval = utc / (24 * 60 * 60 * 1000);
            if (interval < 1) {
                this.get_agent();
                this.getWechatConfig();
            } else {
                localStorage.clear();
                var shopid = getQueryValue("shopid");
                this.$dialog.toast({ mes: "登录过期" });
                this.$router.replace({
                    path: "/login",
                    query: { shopid: shopid },
                });
            }
        } else {
            localStorage.clear();
            var shopids = getQueryValue("shopid");
            this.$dialog.toast({ mes: "请先登录" });
            this.$router.replace({
                path: "/login",
                query: { shopid: shopids },
            });
        }
    },
    methods: {
        //连续扫码出库
        continuousScanCode() {
            this.newScanCode()
        },
        //连续扫码
        newScanCode() {
            var that = this;
            wx.ready(function () {
                wx.checkJsApi({
                    jsApiList: ["scanQRCode"],
                    success: function (res) {
                        if (res.checkResult.scanQRCode === true) {
                            wx.scanQRCode({
                                desc: "scanQRCode desc",
                                needResult: 1,
                                scanType: ["qrCode", "barCode"],
                                success: function (res) {
                                    const getCode = res.resultStr;
                                    let serial_code = getCode.match(
                                        /serial_code=(\S*)&shopid/
                                    )[1];
                                    that.get_new_goods(serial_code);                                   
                                },
                            });
                        } else {
                            this.$dialog.error(
                                "抱歉，当前客户端版本不支持扫一扫"
                            );
                        }
                    },
                    fail: function (res) {
                        that.getWechatConfig();
                        console.log("fail" + res);
                    },
                });
                /* 处理失败验证 */
                wx.error(function (res) {
                    that.getWechatConfig();
                    console.log("配置验证失败: " + res.errMsg);
                });
            });
        },
        //连续扫码获取商品详情
        get_new_goods(code){ 
            get_goods({
                serial_code: code,
            }).then((res) => {
                this.productInfo = res.data;
                this.stock_new_goods()                            
            })
            .catch((err) => {
                this.$dialog.error(err.msg);
            });
        },
        //连续出库
        stock_new_goods() {
            var that = this;
            if (!this.productInfo.serial_code || !this.productInfo.product_id) {
                this.$dialog.error("请先获取商品信息");
            } else if (this.productInfo.status == "1") {
                this.$dialog.error("产品已出库");
            } else if (!this.value) {
                this.$dialog.error("请选择代理商");
            } else {
                var shopid = $store.state.app.shopid;
                stock_goods({
                    serial_code: this.productInfo.serial_code, //溯源码
                    agent_id: this.value, //代理商
                    type: this.productInfo.statu, //是否已出库
                    goods_id: this.productInfo.product_id, //商品id
                    shopid: shopid,
                }).then((res) => {
                    that.get_goods(this.productInfo.serial_code);
                    that.$dialog.toast({ mes: res.msg });
                    that.goScanCode()
                })
                .catch((err) => {
                    this.$dialog.error(err.msg);
                });
            }
        },
        // 1秒延迟再去连续扫码
        goScanCode(){
            var tat = this
            setTimeout(() => {                  
                tat.newScanCode()
            }, 1000);   

        },
        //扫码
        scanCode() {
            var that = this;
            wx.ready(function () {
                wx.checkJsApi({
                    jsApiList: ["scanQRCode"],
                    success: function (res) {
                        if (res.checkResult.scanQRCode === true) {
                            wx.scanQRCode({
                                desc: "scanQRCode desc",
                                needResult: 1,
                                scanType: ["qrCode", "barCode"],
                                success: function (res) {
                                    const getCode = res.resultStr;
                                    let serial_code = getCode.match(
                                        /serial_code=(\S*)&shopid/
                                    )[1];
                                    that.get_goods(serial_code);
                                    // if (getCode.indexOf("serial_code=") > -1) {
                                    //   let serial_code = that.getQueryValue1("serial_code");
                                    //   that.get_goods(serial_code);
                                    //   console.log("参数");
                                    //   that.get_goods(serial_code);
                                    //   that.$dialog.toast({ mes: res.msg });
                                    // }
                                },
                            });
                        } else {
                            this.$dialog.error(
                                "抱歉，当前客户端版本不支持扫一扫"
                            );
                        }
                    },
                    fail: function (res) {
                        that.getWechatConfig();
                        console.log("fail" + res);
                    },
                });
                /* 处理失败验证 */
                wx.error(function (res) {
                    that.getWechatConfig();
                    console.log("配置验证失败: " + res.errMsg);
                });
            });
        },
        getCaption(obj, str, num) {
            var index = obj.lastIndexOf(str);
            obj = obj.substring(index + num, obj.length);
            return obj;
        },
        //获取微信授权信息
        getWechatConfig() {
            getWechatConfig()
                .then((res) => {
                    wx.config({
                        debug: false,
                        appId: res.data.appId,
                        timestamp: res.data.timestamp,
                        nonceStr: res.data.nonceStr,
                        signature: res.data.signature,
                        jsApiList: ["scanQRCode"],
                    });
                })
                .catch((err) => {
                    this.$dialog.error(err.msg);
                });
        },
        //获取代理商
        get_agent() {
            get_agent()
                .then((res) => {
                    this.options = res.data;
                })
                .catch((err) => {
                    this.$dialog.error(err.msg);
                });
        },
        //获取商品信息
        get_goods(code) {
            get_goods({
                serial_code: code,
            })
                .then((res) => {
                    this.productInfo = res.data;
                
                })
                .catch((err) => {
                    this.$dialog.error(err.msg);
                });
        },
        //出库
        stock_goods() {
            var that = this;
            if (!this.productInfo.serial_code || !this.productInfo.product_id) {
                this.$dialog.error("请先获取商品信息");
            } else if (this.productInfo.status == "1") {
                this.$dialog.error("产品已出库");
            } else if (!this.value) {
                this.$dialog.error("请选择代理商");
            } else {
                var shopid = $store.state.app.shopid;
                stock_goods({
                    serial_code: this.productInfo.serial_code, //溯源码
                    agent_id: this.value, //代理商
                    type: this.productInfo.statu, //是否已出库
                    goods_id: this.productInfo.product_id, //商品id
                    shopid: shopid,
                })
                    .then((res) => {
                        that.get_goods(this.productInfo.serial_code);
                        that.$dialog.toast({ mes: res.msg });
                    })
                    .catch((err) => {
                        this.$dialog.error(err.msg);
                    });
            }
        },
    },
};
</script>
<style>
.el-card__header {
    padding: 10px 20px;
}
</style>
<style scoped>
.modelScan {
    height: 100vh;
}
.el-select {
    width: 90%;
    margin: 20px 5%;
}

.text {
    font-size: 14px;
}

.item {
    margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}
.clearfix:after {
    clear: both;
}

.box-card {
    width: 480px;
}
.box-card {
    width: 90%;
    margin: 0 5%;
}
.clearfix {
    font-size: 16px;
}
.scanBtn {
    width: 90%;
    margin: 0px 5%;
}
.bottomBtn {
    position: absolute;
    bottom: 0px;
    margin-bottom: 30px;
}
</style>
